import { WebRoutes } from "consts/enpoints/web";
import { convertToBooleanSwitch } from "util/transformers";
import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { HighRiskMerchant as HighRiskMerchantApi } from "features/ecommerce/api";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingForm, useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";

export const useFinancialInformation = () => {
    const { getApplicationModel } = useOnboardingApplication();

    const { data } = useOnboardingStepData<HighRiskMerchantType.OnboardingFinancialInformation>();

    const withValues = useOnboardingForm({
        save: HighRiskMerchantApi.putOnboardingsHighRiskFinancialInformationSteps,
        route: WebRoutes.Onboarding.HighRiskMerchant,
        getApplicationModel
    });


    const formProps: HighRiskMerchant.FinancialInformation.OnboardingFinancialInformationForm = {
        bootstrapData: {
            maxTransactionVolumeMonth: [
                '0 - 50,000',
                '50,001 - 100,000',
                '100,001 - 500,000',
                '500,001 - 1,000,000',
                '1,000,001+'
            ],
            salesVolumeCurrentMonth: [
                '0 - 50,000',
                '50,001 - 100,000',
                '100,001 - 500,000',
                '500,001 - 1,000,000',
                '1,000,001+'
            ],
            expectedSalesVolumeMonth: [
                '0 - 50,000',
                '50,001 - 100,000',
                '100,001 - 500,000',
                '500,001 - 1,000,000',
                '1,000,001+'
            ]
        },
        initialValues: HighRiskMerchant.FinancialInformation.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: ({
            preferredCurrency,
            avgTransactionNoMonth,
            maxTransactionVolumeMonth,
            currentPercentChargebacksRefundsRatio,
            expectedSalesVolumeMonth,
            maxTransactionNoCustomerMonth,
            estimatedPercentChargebacksRefundsMonth,
            transactionNoCurrentMonth,
            avgTransactionAmount,
            maxTransactionAmount,
            salesVolumeCurrentMonth,
            isProcessingHistoryOverSixMonths,
            usedPsps,
            hasLeftPreviousProcessors,
            leftPreviousProcessorsInput,
            salesCurrencies,
            totalTransactionAmountYearly
        }, helpers) => (
            withValues({
                preferredCurrency,
                avgTransactionNoMonth,
                maxTransactionVolumeMonth,
                expectedSalesVolumeMonth,
                maxTransactionNoCustomerMonth,
                transactionNoCurrentMonth,
                salesVolumeCurrentMonth,
                usedPsps,
                leftPreviousProcessorsInput,
                totalTransactionAmountYearly: String(totalTransactionAmountYearly),
                maxTransactionAmount: String(maxTransactionAmount),
                estimatedPercentChargebacksRefundsMonth: String(estimatedPercentChargebacksRefundsMonth),
                currentPercentChargebacksRefundsRatio: String(currentPercentChargebacksRefundsRatio),
                avgTransactionAmount: String(avgTransactionAmount),
                isProcessingHistoryOverSixMonths: convertToBooleanSwitch(isProcessingHistoryOverSixMonths),
                hasLeftPreviousProcessors: convertToBooleanSwitch(hasLeftPreviousProcessors),
                salesCurrencies: [salesCurrencies]
                    .filter(Boolean)
                    .join()
            }, helpers)
        )
    };

    return {
        ...formProps,
        ...HighRiskMerchant.FinancialInformation.useForm(formProps),
        ...data
    };
};

export default useFinancialInformation;
